import { analyticsAllowed } from "./analytics-policy";
type EventProps = Record<string, string | number | boolean>;

type EventName =
  | "search"
  | "search_results"
  | "filter_change"
  | "filters_cleared"
  | "view_shirt"
  | "click_affiliate"
  | "scan_attempt"
  | "scan_choose"
  | "photo_scan_attempt"
  | "photo_scan_result"
  | "photo_scan_failure"
  | "washtag_scan_result"
  | "washtag_scan_failure"
  | "watchlist_add"
  | "watchlist_remove"
  | "watchlist_change_failed"
  | "sign_in"
  | "auth_result"
  | "password_reset_request"
  | "edit_submitted"
  | "notify_signup"
  | "click_gate_cta";

declare global {
  interface Window {
    plausible?: (
      event: string,
      opts?: { props?: EventProps; callback?: () => void },
    ) => void;
    umami?: {
      track(name: string, data?: EventProps): void;
    };
  }
}

const PLAUSIBLE_DOMAIN = import.meta.env["VITE_PLAUSIBLE_DOMAIN"] as
  | string
  | undefined;
const PLAUSIBLE_API = (import.meta.env["VITE_PLAUSIBLE_API"] as
  | string
  | undefined) ?? "https://plausible.io";

let installed = false;

export function installAnalytics() {
  if (installed || typeof window === "undefined" || !analyticsAllowed()) return;
  installed = true;
  if (!PLAUSIBLE_DOMAIN) return;
  window.__kitdexMarketingLoaded = true;
  const s = document.createElement("script");
  s.defer = true;
  s.setAttribute("data-domain", PLAUSIBLE_DOMAIN);
  s.src = `${PLAUSIBLE_API.replace(/\/$/, "")}/js/script.tagged-events.js`;
  document.head.appendChild(s);
  window.plausible =
    window.plausible ??
    function queued(...args: unknown[]) {
      ((window.plausible as unknown as { q?: unknown[] }).q =
        (window.plausible as unknown as { q?: unknown[] }).q || []).push(args);
    };
}

export function track(name: EventName, props?: EventProps) {
  if (typeof window === "undefined" || !analyticsAllowed()) return;
  try {
    window.umami?.track(name, props);
    window.plausible?.(name, props ? { props } : undefined);
  } catch {
    // Analytics must never break the app.
  }
}
